import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import SEO from '../Components/SEO';

export default function DpdpActFullText() {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/src/static/dpdp-act.md')
      .then(res => res.text())
      .then(setContent);
  }, []);

  return (
    <>
    <SEO
      title="DPDP Act 2023 - Full Text - DPDP Guide"
      description="Read the complete text of India's Digital Personal Data Protection Act, 2023. Full sections, chapters, and schedules."
      keywords="DPDP Act full text, Digital Personal Data Protection Act 2023, India privacy law text"
    />
    <div className="max-w-5xl mx-auto p-8 bg-white rounded-xl shadow-lg">
      <h1 className="text-3xl font-bold text-black mb-6">Digital Personal Data Protection Act, 2023</h1>
      <ReactMarkdown className="prose max-w-none">{content}</ReactMarkdown>
    </div>
    </>
  );
}